import { render, staticRenderFns } from "./Withdrawalbookingsuccess.vue?vue&type=template&id=299609a4"
import script from "./Withdrawalbookingsuccess.vue?vue&type=script&lang=js"
export * from "./Withdrawalbookingsuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports